import React, { useCallback, useEffect, useRef, useState } from 'react'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { IoCreateOutline, IoAddCircleSharp, IoSave, IoCreate } from 'react-icons/io5'
import { Link } from 'react-router-dom'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Icone } from '../../Components/Icones/Index'
import { DataSearch, SearchBox } from '../../Components/SearchBox/SearchBox'
import { Template } from '../../Components/Template/template'
import { classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classBt, classbtVermelho, classbtVerde, classbtAzul, AlertType, Caixa, classBorderLabelDark, classWeigthBt, classbtColunasVermelho, classUserCriarAtt, classDtCriarAtt, classbtCinzaClaro, InputsRefs, barraVermelhoAzul, bgBlue, bgRed, focusLabelRed, focusRed } from '../../Utils/Types'
import { FaMoneyBill1Wave } from 'react-icons/fa6'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faFolder, faExclamation, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { Funcoes } from '../../Utils/Funcoes'
import { LanctoCaixaService } from './LanctoCaixaService'
import { GiMoneyStack } from 'react-icons/gi'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'
import moment from 'moment'

export const LanctoCaixaPage = () => {

    // -----------------------------------------------
    // ----------------- TABS ------------------------
    // -----------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        //{ index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // -----------------------------------------------
    // ------------------ ATRIBUTOS ------------------
    // -----------------------------------------------

    let date = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    const [idCaixa, setIdCaixa] = useState(0)
    const [valor, setValor] = useState("0.00")
    const [data, setData] = useState(date)
    const [tipo, setTipo] = useState("")
    const [historico, setHistorico] = useState("")

    // CONTAS
    const [idConta, setIdConta] = useState(0)
    const [contas, setContas] = useState<DataSearch[]>([])
    const [contasFilter, setContasFilter] = useState<DataSearch[]>([])


    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState(false)
    const [feedbackVisible, setFeedbackVisible] = useState(false)
    const [feedbackMessage, setFeedbackMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // -----------------------------------------------
    // ---------- ATRIBUTOS AUDITORIA ----------------
    // -----------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    const [windowHeight, setWindowHeight] = useState(0)

    // -----------------------------------------------
    // ------------------ SEARCHBOX ------------------
    // -----------------------------------------------
    const [visibleSearchBoxConta, setVisibleSearchBoxConta] = useState<boolean>(false)

    // -----------------------------------------------
    // ---------- ATRIBUTOS TUTORIAL -----------------
    // -----------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //----------------------------------------------------------------------------------------- ATTRIBUTES E EFFECT --------------------------------------------------------------------------- ||
    const GetAttibutes = async () => {
        setLoading(true)

        try {

            const contas = await LanctoCaixaService.GetAttributes()
            setContas(contas.data)
            setContasFilter(contas.data)

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Não foi possível buscar as contas")

        } finally {

            setLoading(false)

        }
    }

    useEffect(() => {
        setWindowHeight(window.innerHeight * 0.75)
        GetAttibutes()
        Inputfocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }

        Inputfocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }


    //------------------------------------------------------------------------------------------------------ INPUTS --------------------------------------------------------------------------- ||
    const handleChangeData = (e: React.ChangeEvent<HTMLInputElement>) => {
        setData(e.target.value)
    }

    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    const handleChangeHistorico = (e: React.ChangeEvent<HTMLInputElement>) => {
        setHistorico(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------ CONTAS --------------------------------------------------------------------------- ||
    const handleClearContaSelecionada = useCallback(() => {
        let newContas = [...contas]
        setContasFilter(newContas)
        setIdConta(0)

        setVisibleSearchBoxConta(false)
        boxFocusConta()
    }, [contas])

    const handleFilterContaClick = useCallback((description: string) => {

        if (description === "") {

            const newContas = [...contas]
            setContasFilter(newContas)

        } else {

            const newContas = [...contas || []].filter((conta) => {
                return conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setContasFilter(newContas || [])
        }
    }, [contas])

    const handleContaSelectClick = useCallback((conta: DataSearch) => {

        if (conta) {
            let newContas = [...contas]
            setContasFilter(newContas)
            setIdConta(conta.id)
        }

        setVisibleSearchBoxConta(false)
        boxFocusConta()
    }, [contas])

    //------------------------------------------------------------------------------------------------------ LANÇAMENTOS --------------------------------------------------------------------------- ||
    const handleNovoLanctoClick = () => {
        setData(date)
        setValor("0.00")
        setHistorico("")
        setTipo("")
        setIdConta(0)

        Inputfocus()
        handleInputFocus()

        if (messageType === 'DANGER') {
            setFeedbackVisible(false)
        }

    }

    const handleSaveClick = async () => {

        setFeedbackVisible(false)
        setLoading(true)

        try {

            const lanctoCaixa: Caixa = {
                id: 0,
                data: data,
                valor: parseFloat(valor),
                historico: historico,
                tipo: tipo === "D" ? "D" : "C",
                idConta: idConta,
                tipoLancto: 'L'
            }

            handleInputFocus()

            const retAPI = await LanctoCaixaService.Save(lanctoCaixa)

            if (retAPI.error) {

                setFeedbackVisible(true)
                setMessageType("DANGER")
                setFeedbackMessage(retAPI.msg || "")

            } else {

                setData(date)
                setValor("0.00")
                setHistorico("")
                setTipo("")
                setIdConta(0)

                setFeedbackVisible(true)
                setMessageType("SUCCESS")
                setFeedbackMessage("Lançamento efetuado com sucesso")

            }

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Houve um erro no lançamento. Por favor, tente novamente")

        } finally {
            setLoading(false)
            Inputfocus()
        }
    }

    const handleCloseFeedbackMessage = () => {
        setFeedbackVisible(false)
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("tipo")
        inputElement?.focus()
    }


    // ---------------------------------------------------------------- FOCUS ABA 1 -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        tipo: useRef(null),
        conta: useRef(null),
        valor: useRef(null),
        data: useRef(null),
        historico: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 1) {
                setVisibleSearchBoxConta(true)
                inputFocusConta()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                event.preventDefault()

                const inputSearchCliente = document.getElementById('inputSearchBox-conta') as HTMLInputElement

                if (document.activeElement === inputSearchCliente) {

                    inputsRefs['valor'].current?.focus()
                    setVisibleSearchBoxConta(false)

                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [])

    const handleInputFocus = () => {
        setVisibleSearchBoxConta(false)
    }

    const boxFocusConta = () => {
        // Move o foco para o input correspondente à chave 'conta'.
        inputsRefs['conta'].current?.focus()
    }

    const clickSearchBoxConta = useCallback(() => {
        setVisibleSearchBoxConta((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                inputFocusConta();
            }
            return newState;
        });
        boxFocusConta();
    }, []);

    const inputFocusConta = () => {
        let inputSearch = document.getElementById(`inputSearchBox-conta`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={feedbackVisible} message={feedbackMessage} type={messageType} onCloseMessage={handleCloseFeedbackMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`min-h-[50px] w-full flex flex-col sm:flex-row items-center py-3 px-2 space-y-2 sm:space-y-0 sm:space-x-2 border border-x-0 border-t-0 border-slate-300 dark:border-slate-700`}>

                            <div className={`flex flex-row items-center`}>
                                <IoCreate className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>Lançamento - Contas</span>
                            </div>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`relative`}>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados de Lançamento</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 `} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <select ref={inputsRefs.tipo} onKeyDown={(e) => handleTabPress(e, 'tipo')} id='tipo' className={`${classInput} ${classInputDark}`} value={tipo} onFocus={handleInputFocus} onChange={handleChangeTipo}>
                                            <option value="C">Crédito</option>
                                            <option value="D">Débito</option>
                                        </select>
                                        <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 xl:col-span-3`}>

                                        <div ref={inputsRefs['conta']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'conta')} />
                                        <div className={`${barraVermelhoAzul} ${idConta > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={contasFilter}
                                            idRegistro={idConta}
                                            label='Conta'
                                            componentId='conta'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxConta}
                                            setDataClick={handleContaSelectClick}
                                            clearDataClick={handleClearContaSelecionada}
                                            filterDataClick={handleFilterContaClick}
                                            clicado={clickSearchBoxConta}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${parseFloat(valor) > 0 ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valor} onKeyDown={(e) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark} ${parseFloat(valor) > 0 ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={valor} onFocus={handleInputFocus} onChange={handleChangeValor} />
                                        <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(valor) > 0 ? '' : focusLabelRed}`}>Valor</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${data != "" ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.data} onKeyDown={(e) => handleTabPress(e, 'data')} id="data" className={`${classInput} ${classInputDark} ${data === "" ? `text-blue-500 dark:text-cyan-300` : ``} ${data != "" ? '' : focusRed} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " disabled={true} value={data} onFocus={handleInputFocus} onChange={handleChangeData} />
                                        <label htmlFor="data" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${data != "" ? '' : focusLabelRed}`}>Data</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-5 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.historico} onKeyDown={(e) => handleTabPress(e, 'historico')} id="historico" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={155} placeholder=" " value={historico} autoComplete='off' onFocus={handleInputFocus} onChange={handleChangeHistorico} />
                                        <label htmlFor="historico" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Histórico</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <button tabIndex={-1} onClick={handleNovoLanctoClick} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveClick} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading ? `Lançar` : `Aguarde`}
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_lancamentoContas.mp4'
                            title='Como fazer um lançamento de conta'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}